import styled from '../../styled';
import { COLORS } from '../../themes/color';

type ProductIconSize = 'xs' | 'sm' | 'md' | 'lg';

const SIZE_STYLES: Record<
  ProductIconSize,
  { width: string; height: string; radius: string }
> = {
  xs: { width: '36px', height: '36px', radius: '10px' },
  sm: { width: '38px', height: '38px', radius: '10px' },
  md: { width: '40px', height: '40px', radius: '10px' },
  lg: { width: '44px', height: '44px', radius: '12px' }
};

export const ProductIcon = styled('div')<{
  $size?: ProductIconSize;
  $muted?: boolean;
}>`
  flex-shrink: 0;
  width: ${(p) => SIZE_STYLES[p.$size ?? 'md'].width};
  height: ${(p) => SIZE_STYLES[p.$size ?? 'md'].height};
  border-radius: ${(p) => SIZE_STYLES[p.$size ?? 'md'].radius};
  background: ${(p) => (p.$muted ? COLORS.GRAY.borderLight : COLORS.PRIMARY_SURFACE)};
  color: ${(p) => (p.$muted ? COLORS.GRAY.muted : COLORS.PRIMARY)};
  display: flex;
  align-items: center;
  justify-content: center;
`;
